module.exports = __webpack_public_path__ + "static/media/binSPIRIT.fc4c3fab.svg";